var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#FEF1CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#FBBA00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 13.2501L25.75 16.3751M20.5417 27.8334H28.875M12.2084 23.6668L11.1667 27.8334L15.3334 26.7918L27.4021 14.723C27.7927 14.3323 28.0121 13.8025 28.0121 13.2501C28.0121 12.6977 27.7927 12.1679 27.4021 11.7772L27.2229 11.598C26.8323 11.2074 26.3024 10.988 25.75 10.988C25.1976 10.988 24.6678 11.2074 24.2771 11.598L12.2084 23.6668Z",
    stroke: "#FBBA00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/editButton.4eec01dc0fa87bce8618896c792b8ea3.svg";
export { ForwardRef as ReactComponent };